import './App.scss';

import { Switch, Route, Redirect } from 'react-router-dom';

import CaptiVision from './pages/captivision/captivision.component';
import CaptiVisionGetStarted from './pages/captivision/guide/get-started.component';
import CaptiVisionGuide from './pages/captivision/guide/guide.component';
import CaptiVisionPrivacy from './pages/captivision/legal/privacy.component';
import CaptiVisionTerms from './pages/captivision/legal/terms.component';
import CaptiVisionStory from './pages/captivision/story/story.component';
import CaptiVisionPricing from './pages/captivision/pricing/pricing.component';
import CaptiVisionTesting from './pages/captivision/testing/testing.component';
import CaptiVisionJoin from './pages/captivision/join/join.component';
import { CVLanguageProvider } from './pages/captivision/i18n/language.component';
import { SHOW_PRICING } from './pages/captivision/captivision.config';
import AnalyticsTracker from './AnalyticsTracker';

// CaptiVision used to live under /captivision on the Synergie Tech site. The
// apps' pairing codes and the tester emails still point there, so send those
// addresses to the same page here. The #fragment is kept: the join page reads
// the session from it.
const LegacyRedirect = ({ location }) => (
  <Redirect to={{ ...location, pathname: location.pathname.replace(/^\/captivision/, '') || '/' }} />
)

function App() {
  return (
    <div className="App">
      <AnalyticsTracker />
      {/* the language the site is read in, shared by every page */}
      <CVLanguageProvider>
        <Switch>
          <Route path='/' exact component={CaptiVision} />
          <Route path='/get-started' exact component={CaptiVisionGetStarted} />
          <Route path='/guide' exact component={CaptiVisionGuide} />
          <Route path='/privacy' exact component={CaptiVisionPrivacy} />
          <Route path='/terms' exact component={CaptiVisionTerms} />
          <Route path='/story' exact component={CaptiVisionStory} />
          {/* only while pricing is public; otherwise /pricing goes home */}
          {SHOW_PRICING ? <Route path='/pricing' exact component={CaptiVisionPricing} /> : null}
          {/* unlisted: only reached from the link emailed to testers */}
          <Route path='/testing' exact component={CaptiVisionTesting} />
          {/* unlisted: pairing codes scanned without CaptiVision Client installed land here */}
          <Route path='/join' exact component={CaptiVisionJoin} />

          <Route path='/captivision' component={LegacyRedirect} />
          <Redirect to='/' />
        </Switch>
      </CVLanguageProvider>
    </div>
  );
}

export default App;
